import { useCallback } from 'react';

import CoursesList from '@sayyesschool/frontend/components/courses-list';
import PageSection from '@sayyesschool/frontend/components/page-section';

import { useCourses } from '@sayyesschool/frontend/features/courses';
import { useEnrollmentActions } from '@sayyesschool/frontend/features/enrollments';
import { IconButton, Menu } from '@sayyesschool/frontend/ui-components';

export default function EnrollmentCourses({ enrollment }) {
    const [courses] = useCourses();
    const actions = useEnrollmentActions();

    const handleAddCourse = useCallback((event, { value }) => {
        if (!value) return;

        return actions.updateEnrollment(enrollment.id, {
            courseIds: enrollment.courseIds.concat(value)
        });
    }, [enrollment, actions]);

    const handleRemoveCourse = useCallback(courseId => {
        return actions.updateEnrollment(enrollment.id, {
            courseIds: enrollment.courseIds.filter(id => id !== courseId)
        });
    }, [enrollment, actions]);

    if (!courses) return null;

    // console.log('EnrollmentCourses', { courses });

    const enrollmentCourses = courses
        .filter(course => enrollment.courseIds.includes(course.id));

    const items = courses
        .filter(course => !enrollment.courseIds.includes(course.id))
        .map(course => ({
            key: course.id,
            value: course.id,
            content: course.title
        }));

    return (
        <PageSection
            title="Курсы"
            actions={
                <Menu
                    trigger={
                        <IconButton
                            icon="add"
                            size="sm"
                        />
                    }
                    items={items}
                    onItemClick={handleAddCourse}
                />
            }
            compact
        >
            {enrollmentCourses.length > 0 &&
                <CoursesList
                    courses={enrollmentCourses}
                    onRemove={handleRemoveCourse}
                />
            }
        </PageSection>
    );
}